import styled from "styled-components";

import { colors } from "@/styles/Variants";

import { theme } from "../../../theme";
import { Option } from "../styles";
const color = colors.bild;
const { margin, breakpoint } = theme;

export const OptionButton = styled(Option)`
  cursor: pointer;
  background: ${color.red500};
  color: ${color.vader0};
  font-weight: 700;
  border-radius: 8px;
  padding: ${margin.large / 2}px ${margin.large}px;
  font-size: 18px;
  @media ${breakpoint.medium} {
    padding: ${margin.medium / 2}px ${margin.medium}px;
    font-size: 16px;
  }
  @media ${breakpoint.small} {
    padding: ${margin.medium / 2}px ${margin.large / 2}px;
    font-size: 16px;
  }
  &:hover,
  &:active {
    background: ${color.red600};
  }
`;
